module.exports = __webpack_public_path__ + "static/img/icon_hzc.f1fec6c5.png";